
export class PKIDomainURLs {
    /**
     * Localhost:4200.
     */
    public static DebbugingUrl: string = "localhost:4200";
    /**
     * DEV PKI url (devplatform.pkisigning.io).
     */
    public static MainDevelopmentUrl: string = "devplatform.pkisigning.io";
    /**
     * Test PKI url (platform.pkisigning.io).
     */
    public static MainTestUrl: string = "testplatform.pkisigning.io";
    /**
     * Acceptation PKI url (platform.pkisigning.io).
     */
    public static MainAcceptationUrl: string = "accplatform.pkisigning.io";
    /**
     * Default PKI url (platform.pkisigning.io).
     * @link PKIDomainUrls.MainNLurl
     */
    public static MainIOurl: string = "platform.pkisigning.io";
    /**
     * Default PKI url (platform.pkisigning.nl).
     * @link PKIDomainUrls.MainIOurl
     */
    public static MainNLurl: string = "platform.pkisigning.nl";
}
